import QuestionBase from 'react-icons/lib/go/question';
import styled from 'styled-components';

export const Question = styled(QuestionBase)`
  margin-bottom: 3px;
`;
